import { useState } from 'react';
import DemoRequestForm from "../DemoRequestForm/DemoRequestForm";

const faqs = [
  {
    question: "Why is Option Bricks Trusted Among Traders?",
    answer: "Option Bricks is renowned for its reliability and dedication to empowering traders with high-quality insights and tools. Our commitment to transparency and consistent results makes us a trusted name in the trading community.",
  },
  {
    question: "What Services Does Option Bricks Offer?",
    answer: "We specialize in options trading, providing professional analysis and actionable recommendations to help traders make informed decisions in dynamic markets.",
  },
  {
    question: "What Markets Does Option Bricks Cover?",
    answer: "Our platform offers comprehensive market coverage, including Nifty, BankNifty, FinNifty, Midcap, Sensex, and Bankex. We ensure you stay ahead with tailored insights across these key market segments.",
  },
  {
    question: "What Makes Option Bricks Analysts Unique?",
    answer: "Our professional analysts have extensive market knowledge and provide well-researched recommendations. Their focus on data-driven strategies ensures you receive top-tier trading advice.",
  },
  {
    question: "How Does Option Bricks Ensure Quality?",
    answer: "We are committed to delivering highly researched trading services and recommendations. Our insights are backed by thorough analysis, ensuring you trade with confidence.",
  },
];

const RequestCallSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="relative bg-white pt-12 pb-12 font-sans overflow-hidden border-t border-gray-100">

      {/* Subtle dotted texture */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.04)_1px,transparent_1px)] bg-[size:22px_22px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_50%,transparent_100%)]"></div>

      <div className="relative container mx-auto px-6 lg:px-12 z-10">

        {/* Header Section */}
        <div className="text-center mb-10 max-w-3xl mx-auto">
          <div className="inline-block px-4 py-1.5 mb-4 rounded-full border border-gray-200 text-xs font-medium tracking-wide uppercase text-gray-600">
            Support & Inquiries
          </div>
          <h2 className="text-4xl md:text-5xl font-semibold text-black mb-6 tracking-tight">
            Have Questions? <br className="md:hidden" />
            <span className="text-[#1e6091]">
              We're Here to Help.
            </span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Explore our frequently asked questions or request a live demo to see exactly how Option Bricks can transform your trading experience.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start">

          {/* ================= FAQ SECTION ================= */}
          <div className="w-full lg:w-1/2 flex flex-col gap-4">
            {faqs.map((faq, index) => {
              const isActive = activeIndex === index;

              return (
                <div
                  key={index}
                  className={`group bg-white rounded-2xl transition-all duration-300 overflow-hidden border ${
                    isActive
                      ? "border-[#1e6091] shadow-[0_10px_30px_rgba(30,96,145,0.12)]"
                      : "border-gray-200 shadow-sm hover:shadow-md hover:border-gray-400"
                  }`}
                >
                  {/* FAQ Question Header */}
                  <button
                    type="button"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={isActive}
                    aria-controls={`faq-answer-${index}`}
                    id={`faq-question-${index}`}
                    className="w-full px-6 py-[2.28rem] text-left flex justify-between items-center cursor-pointer rounded-2xl focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e6091] focus-visible:ring-offset-2 focus-visible:ring-offset-white"
                  >
                    <span className={`font-semibold transition-colors duration-300 pr-4 ${isActive ? "text-black" : "text-gray-800 group-hover:text-black"}`}>
                      {faq.question}
                    </span>

                    {/* Animated Rotating Chevron / Icon */}
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${isActive ? "bg-[#1e6091] text-white" : "bg-gray-100 text-gray-400 group-hover:bg-gray-200 group-hover:text-[#1e6091]"}`}>
                      <svg
                        className={`w-5 h-5 transition-transform duration-500 ease-in-out ${isActive ? "rotate-180" : "rotate-0"}`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2.5}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                  </button>

                  {/* FAQ Answer (Smooth Grid Animation) */}
                  <div
                    id={`faq-answer-${index}`}
                    role="region"
                    aria-labelledby={`faq-question-${index}`}
                    className={`grid transition-all duration-500 ease-in-out ${
                      isActive ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="px-6 pb-5 pt-1 text-gray-500 leading-relaxed border-t border-gray-100 mt-2">
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ================= DEMO REQUEST FORM SECTION ================= */}
          <div className="w-full lg:w-1/2 relative">
            {/* Form Container */}
            <div className="relative bg-white border border-gray-200 rounded-3xl p-8 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.12)]">

              <div className="mb-8 text-center sm:text-left flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#1e6091] flex items-center justify-center flex-shrink-0">
                   <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-black">Request a Callback</h3>
                  <p className="text-sm text-gray-500 font-medium">Get a personalized walkthrough</p>
                </div>
              </div>

              {/* Render your actual form component here */}
              <div className="w-full">
                <DemoRequestForm />
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RequestCallSection;